import {
  BoqActivityPlanStateTypes,
  BoqActivityPlanActionTypes,
} from "./BoqActivityPlan.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: BoqActivityPlanStateTypes = {
  fetchAll: resetApiCallState([]),
};

const BoqActivityPlanReducer = (
  state: BoqActivityPlanStateTypes = INITIAL_STATE,
  action: any
): BoqActivityPlanStateTypes => {
  switch (action.type) {
    case BoqActivityPlanActionTypes.FETCH_ALL_BOQ_ACTIVITY_PLAN:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case BoqActivityPlanActionTypes.FETCH_ALL_BOQ_ACTIVITY_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case BoqActivityPlanActionTypes.FETCH_ALL_BOQ_ACTIVITY_PLAN_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case BoqActivityPlanActionTypes.FETCH_ALL_BOQ_ACTIVITY_PLAN_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default BoqActivityPlanReducer;
